import { createSlice } from "@reduxjs/toolkit";

export const kbSettingSlice = createSlice({
  name: "kbSetting",
  initialState: {
    getKbSettingResult: false,
    getKbSettingLoading: false,
    getKbSettingError: false,
    addKbSettingResult: false,
    addKbSettingLoading: false,
  },
  reducers: {
    kbSettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_KBSETTING":
          return {
            ...state,
            getKbSettingResult: payload.data,
            getKbSettingLoading: payload.loading,
            getKbSettingError: payload.error,
          };
        case "ADD_KBSETTING":
          return {
            ...state,
            addKbSettingResult: payload.data,
            addKbSettingLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { kbSettingReducers } = kbSettingSlice.actions;

export default kbSettingSlice.reducer;
